module.exports = __webpack_public_path__ + "img/6F5A9883.58c2861a.png";